import { ADD_CHECK_LIST, ADD_SYSTEM, ADD_SYSTEM_MEASUREMENT, DELETE_SYSTEM, EDIT_SYSTEM, GET_CHECK_LIST_BY_SYSTEM_ID, GET_SYSTEMS_BY_ORDER_ID, GET_SYSTEMS_CHECK_LIST_MOBILE, GET_SYSTEMS_CHECK_LIST_TABLET, GET_SYSTEMS_FOR_ACCORDION, MOVE_SYSTEM_ROW, REMOVE_SYSTEM_FROM_SYSTEMS_OPENING_PATH, SELECTED_SYSTEM_BY_SYSTEM_ID, SET_SYSTEMS_FOR_ACCORDION, SET_SYSTEM_FOR_SYSTEMS_OPENING_PATH, SHOW_SYSTEMS_POP_UP, UPDATE_SYSTEM_CHECKLIST, UPDATE_CHECKLIST_DATA, MARK_ALL_CHECKLIST_LOADING, RESET_SYSTEMS_FOR_ACCORDION } from "../../constants/customer/orderProcessSystemConstants";
import { getOrderSystemsList, updateNewSystemCheckListSection } from "../../functions/api/orders";
import { markAllChecklistsCorrect } from "../../functions/api/orders";
import * as types from "../types";
import { get } from "lodash";
import { CHECK_LIST_TRANSLATION } from "../../constants/translations/customersPage";



function transformCustomerDataToAccordionTreeResponse(systems) {

    const result = []
    const systemsByLayer = {}
    for (const system of systems) {
        const {
            layer,
            // order,
            parent_system_id,
        } = system;



        if (layer in systemsByLayer) {
            if (parent_system_id in systemsByLayer[layer]) {
                systemsByLayer[layer][parent_system_id].push(system)
            } else {
                systemsByLayer[layer][parent_system_id] = [system];
            }
        } else {
            systemsByLayer[layer] = {
                [parent_system_id]: [system]
            };
        }
    }

    for (const layer in systemsByLayer) {
        const systemLayerObj = {
            layer: parseInt(layer),
            systems: []
        }
        for (const parent_system_id in systemsByLayer[layer]) {
            const obj = {
                parent_system_id: parent_system_id == "null" ? null : parent_system_id,
                systems: []
            }
            for (const system of systemsByLayer[layer][parent_system_id]) {
                obj.systems.push(system);
            }
            systemLayerObj.systems.push(obj);
        }

        result.push(systemLayerObj);


    }
    return result;
}


export const updateSystemChecklistLocal = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SYSTEM_CHECKLIST, payload: data })
    }
}
export const updateAllSystemChecklistLocal = (value)  => {
    return async (dispatch, getState) =>{
        const state = getState();
        const data = get(state.orderProcessSystemReducer.systemsForAccordion, `${state.orderProcessSystemReducer.accordionPath}.checkList.data`) || [];
        data.forEach((row, rowIdx) => {
            dispatch(updateSystemChecklistLocal({ rowIdx, colIdx: 0, value }));
        });
    }  
}
export const updateSystemChecklistServer = (data)  => {
    return async (dispatch, getState) =>{
        try {
            const totalProgress = getState().orderProcessSystemReducer.totalProgress;
            const response = await updateNewSystemCheckListSection({
                ...data,
                checkListProgress: totalProgress
            })
            return response
        } catch (err) {
            console.error('[updateSystemChecklistServer] API error:', err)
            throw err
        }
    }  
}

export const markAllChecklist = (path, value, orderProcessId, orderId, actualSystemId, processId) => {
    return async (dispatch, getState) => {
        if (getState().orderProcessSystemReducer.isMarkAllLoading) return;
        dispatch({ type: MARK_ALL_CHECKLIST_LOADING, payload: { loading: true } });
        dispatch({ type: UPDATE_CHECKLIST_DATA, payload: { path, value, response: null } });

        const correct = value === CHECK_LIST_TRANSLATION.PROPER;

        const state = getState();
        const data = get(state.orderProcessSystemReducer.systemsForAccordion, `${state.orderProcessSystemReducer.accordionPath}.checkList.data`) || [];

        if (data?.length) {
            data.forEach((row, rowIdx) => {
                dispatch(updateSystemChecklistLocal({ rowIdx, colIdx: 0, value }));
            });
        }

        try {
            const totalProgress = getState().orderProcessSystemReducer.totalProgress;
            const requestBody = {
                order_id: orderId,
                actual_system_id: actualSystemId,
                correct,
                orderProcessId,
                process_id: processId,
                selected_process: processId,
                checkListProgress: totalProgress
            };
            const response = await markAllChecklistsCorrect(requestBody);

            dispatch({ type: UPDATE_CHECKLIST_DATA, payload: { path, value, response } });
            //await dispatch(systemActionsCreator.getSystemsByOrderId(orderId, processId));
        } catch (err) {
            console.error('markAllChecklist API error:', err);
        } finally {
            dispatch({ type: MARK_ALL_CHECKLIST_LOADING, payload: { loading: false } });
        }
    };
}

export const systemActionsCreator = {
    getSystemsCheckListMobile: () => ({ type: GET_SYSTEMS_CHECK_LIST_MOBILE }),
    getSystemsCheckListTablet: () => ({ type: GET_SYSTEMS_CHECK_LIST_TABLET }),
    getSystemsByOrderId: (orderId, processId = '') => {
        return async (dispatch) => {
            dispatch({ type: RESET_SYSTEMS_FOR_ACCORDION })
            const response = await getOrderSystemsList(orderId, processId);
            dispatch({ type: GET_SYSTEMS_BY_ORDER_ID, payload: response.result })
            dispatch({ type: SET_SYSTEMS_FOR_ACCORDION, payload: { response, processId } })
        }
    },
    getSystemsByCustomer: (customer) => {

        return async (dispatch) => {
            try {
                const response = transformCustomerDataToAccordionTreeResponse(customer.systems);

                dispatch({ type: GET_SYSTEMS_BY_ORDER_ID, payload: response })
                dispatch({ type: SET_SYSTEMS_FOR_ACCORDION, payload: { response: { result: response } } })
            } catch (err) {
                console.log("Error", err);
            }

        }
    },

    getSystemsForAccordion: () => {
        return ({ type: GET_SYSTEMS_FOR_ACCORDION })
    },
    addSystem: (system) => ({
        type: ADD_SYSTEM, payload: system
    }),
    selectedSystemBySystemId: (selectedBy) => {
        return ({ type: SELECTED_SYSTEM_BY_SYSTEM_ID, payload: selectedBy })
    },
    editSystem: (system) => ({
        type: EDIT_SYSTEM, payload: system
    }),
    deleteSystem: (deleteBy) => {
        return ({
            type: DELETE_SYSTEM, payload: deleteBy
        })
    },
    getCheckListBySystemId: (systemId) => {
        return ({
            type: GET_CHECK_LIST_BY_SYSTEM_ID, payload: systemId
        })
    },
    moveSystemRow: (currentRowInfo) => ({ type: MOVE_SYSTEM_ROW, payload: currentRowInfo }),
    addCheckList: () => ({ type: ADD_CHECK_LIST }),
    setSystemForAccordion: () => {
        return ({
            type: SET_SYSTEMS_FOR_ACCORDION,
        })
    },
    setSystemsOpeningPath: (system) => ({ type: SET_SYSTEM_FOR_SYSTEMS_OPENING_PATH, payload: system }),
    removeSystemFromOpeningPath: (system) => ({ type: REMOVE_SYSTEM_FROM_SYSTEMS_OPENING_PATH, payload: system }),

    addSystemMeasurement: (measurement) => ({ type: ADD_SYSTEM_MEASUREMENT, payload: measurement }),


    showSystemsPopup: (boolean) => ({ type: SHOW_SYSTEMS_POP_UP, payload: boolean }),



}